import { useEffect, useRef } from "react";

export default function VideoPlayer({ src, controls = false, caption = "", maxHeight = "400px" }) {
const bucketUrl = "https://storage.googleapis.com/sportynerd-bucket1";

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {}); // catch needed for autoplay policy
        } else {
          video.pause();
        }
      },
      {
        threshold: 0, // fire as soon as any part is visible
        rootMargin: "-20% 0% -20% 0%" // extend viewport by 20% top and bottom (120% of view)
      }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <div style = { { padding : "4px 0px" } }>
      <video
      ref={videoRef}
      src={bucketUrl + src}
      muted
      loop
      playsInline
      controls={controls}
      style={{
          display: "block",   // ← removes inline-block gap that can cause overflow
          maxWidth: "100%",   // ← shrinks if video is wider than container, never stretches
          maxHeight: maxHeight,
          objectFit: "contain",
      }}
      />
      {caption && <p className = "caption" style={{ textAlign: "left" }}>{caption}</p>}
    </div>
  );
}